import React, { useState } from "react";
import SearchBar from "../components/SearchBar";
import Navbar from "../components/Navbar";
import hamburger_icon from "../assets/icons/hamburger_icon.png";
import templates_icon from "../assets/icons/templates_icon.png";
import socialMedia_one from "../assets/images/socialmedia-one.png";
import bi_filter_yellow from "../assets/icons/bi_filter_yellow.png";
import SocialMediaFilter from "../components/SocialMediaFilter";
import PosterTemplate from "../components/modals/PosterTemplate";

const SocialMedia = () => {
  const [isNavbarVisible, setIsNavbarVisible] = useState(false);
  const [filter, setFilter] = useState(false);
  const [posterTemplate, setPosterTemplate] = useState(false);

  const toggleNavbar = () => {
    setIsNavbarVisible(!isNavbarVisible);
  };
  return (
    <div className="mb-8">
      <div className="flex items-center justify-center w-full">
        <div
          className="items-center justify-center hidden hamburger"
          onClick={toggleNavbar}
        >
          <img
            src={hamburger_icon}
            alt="hamburger"
            className="object-contain"
          />
        </div>
        <div className="flex items-center justify-center w-full">
          <SearchBar categoryName="Dashboard" />
        </div>
        <div className="absolute top-0 w-[70%] z-20 bg-white rounded-lg mt-16">
          {isNavbarVisible && <Navbar />}
        </div>
      </div>
      <div className="flex justify-between w-[95%]">
        <div className={`${filter ? "w-[70%]" : "w-[90%]"}`}>
          <div className="flex items-center mt-6 mb-2 ml-4">
            <img src={templates_icon} alt="templates" className="w-4 mr-1" />
            <div className="text-[16px]">Templates for you</div>
          </div>
          <p className="ml-4 mt-11 italic text-[14px]">New Collection</p>
          <div className="w-full ml-4 flex flex-wrap">
            <img
              src={socialMedia_one}
              alt="social"
              className="w-60 mr-8 mt-4 cursor-pointer"
              onClick={() => setPosterTemplate(true)}
            />
            <img
              src={socialMedia_one}
              alt="social"
              className="w-60 mr-8 mt-4 cursor-pointer"
              onClick={() => setPosterTemplate(true)}
            />
            <img
              src={socialMedia_one}
              alt="social"
              className="w-60 mr-8 mt-4 cursor-pointer"
              onClick={() => setPosterTemplate(true)}
            />
          </div>
          <p className="ml-4 mt-11 italic text-[14px]">Offers</p>
          <div className="w-full ml-4 flex flex-wrap">
            <img
              src={socialMedia_one}
              alt="social"
              className="w-60 mr-8 mt-4 cursor-pointer"
              onClick={() => setPosterTemplate(true)}
            />
            <img
              src={socialMedia_one}
              alt="social"
              className="w-60 mr-8 mt-4 cursor-pointer"
              onClick={() => setPosterTemplate(true)}
            />
            <img
              src={socialMedia_one}
              alt="social"
              className="w-60 mr-8 mt-4 cursor-pointer"
              onClick={() => setPosterTemplate(true)}
            />
            <img
              src={socialMedia_one}
              alt="social"
              className="w-60 mr-8 mt-4 cursor-pointer"
              onClick={() => setPosterTemplate(true)}
            />
          </div>
        </div>

        <div className={`${filter ? "w-[14rem]" : ""} mt-4`}>
          <div className="flex justify-end w-full">
            <div className="w-full flex justify-end">
              <img
                src={bi_filter_yellow}
                alt="filters"
                className="cursor-pointer w-10 shadow-lg"
                onClick={() => setFilter(!filter)}
              />
            </div>
          </div>
          {filter ? (
            <div className="w-full exhibition-filter">
              <SocialMediaFilter />
            </div>
          ) : (
            ""
          )}
        </div>

        {posterTemplate ? (
          <PosterTemplate setPosterTemplate={setPosterTemplate} />
        ) : null}
      </div>
    </div>
  );
};

export default SocialMedia;
